import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
// import goldlog from "@ali/goldlog";
import classnames from 'classnames';
import jsonp from "@alife/common-jsonp";
import "./index.scss";
var Dpa = /*#__PURE__*/function (_Component) {
  function Dpa(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.dj = _this.dj.bind(_this);
    return _this;
  }
  _inheritsLoose(Dpa, _Component);
  var _proto = Dpa.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      pid = _this$props.pid,
      templateId = _this$props.templateId,
      session_id = _this$props.session_id,
      adgroup_id = _this$props.adgroup_id,
      blockId = _this$props.blockId,
      serveDpa = _this$props.serveDpa,
      normalDpa = _this$props.normalDpa,
      salesDpa = _this$props.salesDpa;
    var dpaFullData = [].concat(serveDpa ? serveDpa.slice(0, 2) : [], normalDpa ? normalDpa === null || normalDpa === void 0 ? void 0 : normalDpa.slice(0, 1) : [], salesDpa ? salesDpa === null || salesDpa === void 0 ? void 0 : salesDpa.slice(0, 1) : []);
    var materialIds = dpaFullData.map(function (v) {
      return v.materialId;
    }).join(",");

    // dpaFullData.length > 0 &&
    //   goldlog.record(
    //     "/btob.wxb.zhurong_exp",
    //     "EXP",
    //     `exp_type='dpa'&pid=${pid}&templateId=${templateId}&blockId=${blockId}&materialIds=${materialIds}&session_id=${session_id}&adgroup_id=${adgroup_id}`,
    //     "GET"
    //   );
  };
  _proto.dj = function dj() {
    var eurl = this.props.eurl;
    jsonp({
      callbackParamName: "callback",
      url: eurl
    })["catch"]();
  };
  _proto.render = function render() {
    var _normalDpa$, _salesDpa$;
    var _this$props2 = this.props,
      serveDpa = _this$props2.serveDpa,
      normalDpa = _this$props2.normalDpa,
      salesDpa = _this$props2.salesDpa,
      loginId = _this$props2.loginId,
      isPcSem = _this$props2.isPcSem;
    var serveDpaData = (serveDpa === null || serveDpa === void 0 ? void 0 : serveDpa.slice(0, 2)) || [];
    var alitalkidUTF8 = encodeURIComponent(loginId + "" || "");
    return /*#__PURE__*/React.createElement("div", {
      className: "zr-dpa"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dpa-first-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "serve-dpa-container"
    }, serveDpaData.map(function (item, index) {
      return /*#__PURE__*/React.createElement("span", {
        className: "dpa-content",
        title: item.v,
        key: index
      }, item.v);
    })), /*#__PURE__*/React.createElement("div", {
      className: "normal-dpa-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dpa-content"
    }, normalDpa === null || normalDpa === void 0 ? void 0 : (_normalDpa$ = normalDpa[0]) === null || _normalDpa$ === void 0 ? void 0 : _normalDpa$.v))), /*#__PURE__*/React.createElement("div", {
      className: "dpa-second-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames("dpa-content", {
        "salesDpa": isPcSem
      })
    }, salesDpa === null || salesDpa === void 0 ? void 0 : (_salesDpa$ = salesDpa[0]) === null || _salesDpa$ === void 0 ? void 0 : _salesDpa$.v), isPcSem && /*#__PURE__*/React.createElement("span", {
      className: "wangwang",
      onClick: this.dj
    }, /*#__PURE__*/React.createElement("div", {
      className: "common-wangwang-tag"
    }, /*#__PURE__*/React.createElement("span", {
      className: "J_WangWang",
      "data-nick": alitalkidUTF8,
      "data-encode": "true",
      "data-icon": "static",
      "data-from": "cnalichn",
      "data-display": "inline"
    })))));
  };
  return Dpa;
}(Component);
export default Dpa;